import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledImage = styled(Box)({
  maxWidth: "100%",
}) as typeof Box;
